import React, { ReactNode } from "react";
import { Heading, HeadingProps } from "@/shared/components/ui/Heading";
interface SectionHeadingProps {
    icon: ReactNode;
    title: string;
    headingLevel?: HeadingProps["level"];
}

const SectionHeading: React.FC<SectionHeadingProps> = ({ icon, title, headingLevel = "h3" }) => {
    return (
        <div className="flex flex-col items-center gap-3">
            <div className="flex size-16 items-center justify-center">{icon}</div>
            <Heading level={headingLevel} className="text-center text-base font-semibold">
                {title}
            </Heading>
        </div>
    );
};

export default SectionHeading;
